import React, { useEffect, useState } from 'react';
import Api from '../../../api/Api';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from '../../../components/tag/Row';
import ErrorTooltip from '../../../components/ErrorTooltip';
import Validation from '../../../utils/Validation';

// eslint-disable-next-line no-undef
const { id: module_id } = module;

const FieldErrors = ({ errors }) => (
  <>
    {!!errors && (
      <div className="ot-userinfo-error">
        {errors.map((error, index) => (
          <ErrorTooltip key={index} error={error} />
        ))}
      </div>
    )}
  </>
);

const PersonForm = (props) => {
  const { person, status, onSubmit, intl } = props;

  const initialState = {
    phone: person.phone,
    phoneConfirm: '',
    email: person.email,
    confirmEmail: '',
    showEditEmail: false,
    showEditPhone: false,
    status: null,
    hasErrors: false,
    errors: {
      phone: null,
      phoneConfirm: null,
      email: null,
      confirmEmail: null,
    },
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    setState({
      ...state,
      phone: person.phone,
      phoneConfirm: initialState.phoneConfirm,
      email: person.email,
      confirmEmail: initialState.confirmEmail,
    });
  }, [person]);

  const handleKeyPress = (event) => {
    const field = event.target.name;
    if (event.key === 'Enter') {
      onSubmit(field);
    }
  };

  const isValidEmail = () => {
    const errors = Validation.validateEmail(state.email, state.confirmEmail);
    if (errors.email.length > 0 || errors.confirmEmail.length > 0) {
      setState({ ...state, errors: { ...errors }, hasErrors: true });
      return false;
    }
    return true;
  };

  const isValidPhone = (field) => {
    const errors = Validation.validatePhone(
      field,
      state.phone,
      state.phoneConfirm,
      {}
    );
    if (errors.phone.length > 0 || errors.phoneConfirm.length > 0) {
      setState({ ...state, errors: { ...errors }, hasErrors: true });
      return false;
    }
    return true;
  };

  const handleSubmit = (field) => {
    setState({ ...state, errors: initialState.errors, hasErrors: false });
    switch (field) {
      case 'email':
        if (isValidEmail()) {
          onSubmit(field, state.email);
          setState({ ...state, showEditEmail: false });
        }
        break;
      case 'phone':
        if (isValidPhone(field)) {
          onSubmit(field, state.phone);
          setState({ ...state, showEditPhone: false });
        }
        break;
      default:
        break;
    }
  };

  const cancelEdit = (field) => {
    switch (field) {
      case 'email':
        setState({
          ...state,
          email: initialState.email,
          confirmEmail: initialState.confirmEmail,
          showEditEmail: false,
          errors: {
            ...state.errors,
            email: initialState.errors.email,
            confirmEmail: initialState.errors.confirmEmail,
          },
        });
        break;
      case 'phone':
        setState({
          ...state,
          phone: initialState.phone,
          phoneConfirm: initialState.phoneConfirm,
          showEditPhone: false,
          errors: {
            ...state.errors,
            phone: initialState.errors.phone,
            phoneConfirm: initialState.errors.phoneConfirm,
          },
        });
        break;
      default:
        break;
    }
  };

  const noAddressMessage = (
    <FormattedMessage
      id={'no.address.information'}
      values={{
        icon: <i className="icon-external-link fa ot-icon ot-icon--blue" />,
        a: (chunks) => (
          <a
            href="https://www.posti.fi/fi/henkiloille/muuttoilmoitus/"
            target="_blank"
            rel="noreferrer noopener"
          >
            {chunks}
          </a>
        ),
      }}
    />
  );

  return (
    <div className="row-fluid ot-userinfo">
      <div className="span12 ot-userinfo__info">
        <div className="form-horizontal">
          <div className="row-fluid">
            <div className="span12">
              <span className="ot-userinfo__info__name">
                {person.wholeName}
              </span>
              <br />
              <span className="ot-userinfo__info__hetu">{person.hetu}</span>
            </div>
          </div>
          <hr />
          <div className="row-fluid">
            <div className="span12">
              {!Api.getHpaState() && (
                <div className="control-group">
                  <span className="ot-userinfo-preview-label">
                    <FormattedMessage id={`${module_id}.address.group.label`} />
                  </span>
                  <div className="controls">
                    <span
                      className={'ot-userinfo-preview-field'}
                      style={{ width: '90%' }}
                    >
                      {person.address ? person.address : noAddressMessage}
                    </span>
                  </div>
                </div>
              )}
              <div className="control-group">
                <span
                  className="ot-userinfo-preview-label"
                  style={{ position: 'relative', top: '11px' }}
                >
                  <FormattedMessage id={`${module_id}.email.group.label`} />
                </span>
                <div className="controls">
                  {state.showEditEmail ? (
                    <div className="ot-userinfo-editing-group">
                      <label htmlFor="email">
                        <span className="ot-userinfo-label">
                          <FormattedMessage id={`${module_id}.email.label`} />
                        </span>
                        <input
                          className={!!state.errors.email && 'error'}
                          disabled={!state.showEditEmail}
                          type="text"
                          name="email"
                          id="email"
                          value={state.email}
                          onKeyPress={handleKeyPress}
                          onChange={(e) =>
                            setState({ ...state, email: e.target.value })
                          }
                        />
                        <FieldErrors errors={state.errors.email} />
                      </label>
                      <label htmlFor="confirmEmail">
                        <span className="ot-userinfo-label">
                          <FormattedMessage
                            id={`${module_id}.confirm.email.label`}
                          />
                        </span>
                        <input
                          className={!!state.errors.confirmEmail && 'error'}
                          disabled={!state.showEditEmail}
                          type="text"
                          name="confirmEmail"
                          id="confirmEmail"
                          value={state.confirmEmail}
                          onKeyPress={handleKeyPress}
                          onChange={(e) =>
                            setState({ ...state, confirmEmail: e.target.value })
                          }
                        />
                        <FieldErrors errors={state.errors.confirmEmail} />
                      </label>
                      <div className="ot-userinfo-button-group">
                        <button
                          className="ot-button"
                          onClick={() => cancelEdit('email')}
                        >
                          <FormattedMessage id="cancel" />
                        </button>
                        <button
                          className="ot-button"
                          onClick={() => handleSubmit('email')}
                        >
                          <FormattedMessage id="save" />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <span className={'ot-userinfo-preview-field'}>
                        {!state.email ? 'Ei sähköpostia' : state.email}
                      </span>
                      <button
                        autoFocus
                        className="edit-field"
                        // eslint-disable-next-line no-undef
                        aria-label={intl.messages['edit']}
                        onClick={() =>
                          setState({
                            ...state,
                            showEditEmail: true,
                            errors: {
                              phone: null,
                              phoneConfirm: null,
                              email: null,
                              confirmEmail: null,
                            },
                            hasErrors: false,
                          })
                        }
                      >
                        <i className="icon-pencil edit-field" />
                        <span className={'ot-userinfo-edit-label'}>
                          {
                            // eslint-disable-next-line no-undef
                            intl.formatMessage({ id: 'edit' })
                          }
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="control-group">
                <span
                  className="ot-userinfo-preview-label"
                  style={{ position: 'relative', top: '11px' }}
                >
                  <FormattedMessage id={`${module_id}.phone.group.label`} />
                </span>
                <div className="controls">
                  {state.showEditPhone ? (
                    <div className="ot-userinfo-editing-group">
                      <label htmlFor="phone">
                        <span className="ot-userinfo-label">
                          <FormattedMessage id={`${module_id}.phone.label`} />
                        </span>
                        <input
                          autoFocus
                          // eslint-disable-next-line no-undef
                          aria-label={intl.formatMessage({
                            id: 'phone.number',
                          })}
                          className={!!state.errors.phone && 'error'}
                          disabled={!state.showEditPhone}
                          type="text"
                          name="phone"
                          id="phone"
                          value={state.phone}
                          onKeyPress={handleKeyPress}
                          onChange={(e) =>
                            setState({ ...state, phone: e.target.value })
                          }
                        />
                        <FieldErrors errors={state.errors.phone} />
                      </label>
                      <label htmlFor="phoneConfirm">
                        <span className="ot-userinfo-label">
                          <FormattedMessage
                            id={`${module_id}.confirm.phone.label`}
                          />
                        </span>
                        <input
                          // eslint-disable-next-line no-undef
                          aria-label={intl.formatMessage({
                            id: 'confirm.phone.number',
                          })}
                          className={!!state.errors.phoneConfirm && 'error'}
                          disabled={!state.showEditPhone}
                          type="text"
                          name="phoneConfirm"
                          id="phoneConfirm"
                          value={state.phoneConfirm}
                          onKeyPress={handleKeyPress}
                          onChange={(e) =>
                            setState({ ...state, phoneConfirm: e.target.value })
                          }
                        />
                        <FieldErrors errors={state.errors.phoneConfirm} />
                      </label>
                      <div className="ot-userinfo-button-group">
                        <button
                          className="ot-button"
                          onClick={() => cancelEdit('phone')}
                        >
                          <FormattedMessage id="cancel" />
                        </button>
                        <button
                          className="ot-button"
                          onClick={() => handleSubmit('phone')}
                        >
                          <FormattedMessage id="save" />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <span className={'ot-userinfo-preview-field'}>
                        {state.phone}
                      </span>
                      <button
                        className="edit-field"
                        // eslint-disable-next-line no-undef
                        aria-label={intl.messages['edit']}
                        onClick={() =>
                          setState({
                            ...state,
                            showEditPhone: true,
                            errors: {
                              phone: null,
                              phoneConfirm: null,
                              email: null,
                              confirmEmail: null,
                            },
                            hasErrors: false,
                          })
                        }
                      >
                        <i className="icon-pencil edit-field" />
                        <span className={'ot-userinfo-edit-label'}>
                          {
                            // eslint-disable-next-line no-undef
                            intl.formatMessage({ id: 'edit' })
                          }
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Row>{status}</Row>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(PersonForm);
